import { ParametrosAssociadoResponse } from 'api/Associado/parametros';

import { IEventosPorAssociado } from 'store/modules/AssembleiasAssociadoReducer';

interface ParametrosState {
  dadosVideoTexto: ParametrosAssociadoResponse;
  isLoading: boolean;
  dadosLoaded: boolean;
  listaEvento: IEventosPorAssociado[];
  hideConvidado: boolean;
}

type ParametrosActionType =
  | 'loading'
  | 'setDadosVideoTexto'
  | 'setListaEvento'
  | 'videoTextoLoaded'
  | 'toggleConvidado';

interface ParametrosAction {
  type: ParametrosActionType;
  value?: any;
}

export const parametrosAssociadoInitialState: ParametrosState = {
  dadosVideoTexto: { configTexto: false, urlVideo: '', texto: null },
  isLoading: true,
  dadosLoaded: false,
  listaEvento: [],
  hideConvidado: true,
};

export const parametrosReducer = (
  state: ParametrosState,
  action: ParametrosAction
): ParametrosState => {
  switch (action.type) {
    case 'loading':
      return { ...state, isLoading: action.value };
    case 'videoTextoLoaded':
      return { ...state, dadosLoaded: action.value };
    case 'setDadosVideoTexto':
      return { ...state, dadosVideoTexto: action.value };
    case 'setListaEvento':
      return { ...state, listaEvento: action.value };
    case 'toggleConvidado':
      return { ...state, hideConvidado: !state.hideConvidado };
    default:
      return state;
  }
};
